import { ChangeEvent, FocusEvent, KeyboardEvent, MouseEvent } from 'react';

import { InputTypes } from '@/common/Input/types';

export type HandlerWithValue<V, E> = (value?: V, event?: E) => void;

export const withValue = function <
  T extends ChangeEvent<HTMLInputElement> | FocusEvent<HTMLInputElement> | KeyboardEvent<HTMLInputElement> | MouseEvent<HTMLInputElement>,
>(handler: (value: InputTypes.ValueProp, event: T) => void, value: InputTypes.ValueProp): (event: T) => void {
  return (event: T): void => {
    if (event?.target?.['value'] !== undefined) value = event.target['value'];
    handler?.(value, event);
  };
};
